export default {
      id: "pptx-usage",
      viewBox: "0 0 31 32",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#pptx",
      toString: function () {
        return this.url;
      }
    }